import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import userReducer from './slices/user';
import subscriptionReducer from './slices/subscription';
import analyticsReducer from './slices/analytics';
import appReducer from './slices/app';
import decksReducer from './slices/decks';
import cardsReducer from './slices/cards';
import dashboardReducer from './slices/dashboard';
import leaderboardReducer from './slices/leaderboard';
import focusReducer from './slices/focus';
import notificationsReducer from './slices/notifications';
import adminUsersReducer from './slices/adminUsers';
import adminAuditReducer from './slices/adminAudit';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const appPersistConfig = {
  key: 'app',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['isOnboarded', 'answers']
};


const rootReducer = combineReducers({
  app: persistReducer(appPersistConfig, appReducer),
  user: userReducer,
  subscription: subscriptionReducer,
  analytics: analyticsReducer,
  decks: decksReducer,
  cards: cardsReducer,
  dashboard: dashboardReducer,
  leaderboard: leaderboardReducer,
  focus: focusReducer,
  notifications: notificationsReducer,
  adminUsers: adminUsersReducer,
  adminAudit: adminAuditReducer,
});

export { rootPersistConfig, rootReducer };
